import { firebase } from '@firebase/app';
import '@firebase/firestore';

const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyBsaTCzow-FdZvsNkgCM_H3euln6x_MRdY',
  authDomain: 'https://wedisgustourselves.firebaseapp.com/',
  databaseURL: 'https://wedisgustourselves.firebaseapp.com/',
  projectId: 'wedisgustourselves',
  // storageBucket: "your-project.appspot.com",
  // messagingSenderId: "xxxxxxxxxxxx"
});

export const db = firebaseApp.firestore();